import { validateStringInput } from '../utils/formValidationHelpers';

export interface UpdatePasswordInputs {
    oldPassword: string;
    password: string;
}
export interface UpdatePasswordRequest {
    oldPassword: string;
    password: string;
}

/**
 * buildChangePassword
 *
 * @description
 * Builds an object matching the structure expected by the server in a request to
 * update an existing user's password
 */
export function buildNewPassword(args: UpdatePasswordInputs): UpdatePasswordRequest {
    return {
        oldPassword: validateStringInput('oldPassword', args.oldPassword),
        password: validateStringInput('password', args.password),
    };
}
